import React ,{ useEffect, useState }from "react";
import { TextField, IconButton, Slider} from "@fluentui/react";
import { t } from "i18next";
import { ACTIONS } from "../../../../constants/Constants";
import "../../../User/helpers/InputFileContainerCSS.css";

const positionOptions = [
  { key: "center", text: "Center" },
  { key: "top-left", text: "Top Left" },
  { key: "top-right", text: "Top Right" },
  { key: "bottom-left", text: "Bottom Left" },
  { key: "bottom-right", text: "Bottom Right" },
];

const WatermarkConfiguration = (props) => {
  const isViewMode = props.action === ACTIONS.VIEW;

  const handleFileChange = (ev) => {
    const file = ev.target.files[0];
    if (file) {
      props.values.watermarkImage = file;
      props.values.isWatermarkImageDeleted = 0;
      setSelectedFileName(file.name);
      if (props.setFieldValue) {
        props.setFieldValue("watermarkImage", file);
        props.setFieldValue("isWatermarkImageDeleted", 0);
        props.setFieldValue("watermarkOpacity", 100);
        props.setFieldValue("watermarkWidth", 100);
        props.setFieldValue("watermarkRotation", 0);
      }
    }
  };

  const handleOpacityChange = (e, newValue) => {
    const val = Math.min(100, Math.max(0, parseInt(newValue, 10) || 0));
    props.values.watermarkOpacity = val;
    if (props.setFieldValue) props.setFieldValue("watermarkOpacity", val);
  };
  const handleWidthChange = (e, newValue) => {
    const val = Math.min(100, Math.max(0, parseInt(newValue, 10) || 0));
    props.values.watermarkWidth = val;
    if (props.setFieldValue) props.setFieldValue("watermarkWidth", val);
  }
  const handleRotationChange = (e, newValue) => {
    const val = Math.min(360, Math.max(0, parseInt(newValue, 10) || 0));
    props.values.watermarkRotation = val;
    if (props.setFieldValue) props.setFieldValue("watermarkRotation", val);
  };
   const [watermarkImage, setWatermarkImage] = useState(props.watermarkImageValue ? true : false);
  const [selectedFileName, setSelectedFileName] = useState("");
    const hasWatermarkImage =
    (props.watermarkImageValue && props.values.isWatermarkImageDeleted == 0) ||
    props.values.watermarkImage instanceof File;


  return (
    <div className="ms-Grid" dir="ltr" style={{ marginTop: "15px" }}>
      <div className="form-section-header" style={{ marginBottom: "8px" }}>
        <span style={{ fontSize: "20px", padding: "5px 0px" }}>
          {t("hospital.watermark-configuration")}
        </span>
      </div>
      {isViewMode ? (
        <>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div className="form-heading">{t("hospital.watermark-image")}</div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.watermarkImageValue ? (
                  <img
                    src={props.watermarkImageValue || props.watermarkImageValue}
                    alt="Watermark"
                    style={{ maxHeight: "150px", maxWidth: "200px", border: "1px solid #ccc", borderRadius: "4px" }}
                  />
                ) : "No Watermark Image Found"}
              </div>
            </div>
            {props.watermarkImageValue && props.values.isWatermarkImageDeleted == 0 && (
            <>
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div className="form-heading">{t("hospital.watermark-opacity")}</div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.values.watermarkOpacity ?? 100}%
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div className="form-heading">{t("hospital.watermark-width")}</div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.values.watermarkWidth ?? 100}%
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                <div className="form-heading">{t("hospital.watermark-rotation")}</div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                {props.values.watermarkRotation ?? 0}&deg;
              </div>
            </div>
            </>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="ms-Grid-row" style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            <label>Watermark Image:</label>
            <div>
                {(props.watermarkImageValue != null &&  props.watermarkImageValue != "" && watermarkImage && props.values.isWatermarkImageDeleted == 0) &&(
                <img
                  src={props.watermarkImageValue || props.watermarkImageValue}
                  alt="Watermark"
                  style={{  maxHeight:"150px", maxWidth: "200px", border: "1px solid #ccc", borderRadius: "4px" }}
                />
                 )}
                </div>
           
          </div>
          <div className="ms-Grid-row">
            <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
          <div style={{ marginTop: "8px", display: "flex", alignItems: "center", gap: "8px" }}>
              <input
                type="file"
                id="watermarkImage"
                name="watermarkImage"
                className="file-input-container"
                accept=".JPEG,.jpeg,.PNG,.png,.JPG,.jpg"
                onChange={handleFileChange}
                style={{ width: "112px", overflow: "hidden" }}
              />
              <label style={{ marginLeft: "10px" }} htmlFor="watermarkImage">
                {props.values.watermarkImage instanceof File ? selectedFileName : (props.watermarkImageValue && props.values.isWatermarkImageDeleted == 0 ? props.values.watermarkImageUrl : "")}
              </label>
              {(((props.watermarkImageValue != null && props.watermarkImageValue != "" && watermarkImage) || (props.watermarkImageFileName != null && props.watermarkImageFileName != "") || props.values.watermarkImage instanceof File) && (props.values.isWatermarkImageDeleted == 0)) &&(
                    <IconButton
                    iconProps={{ iconName: "Delete" }}
                    title="Clear Watermark Image"
                    ariaLabel="Clear Watermark Image"
                    style={{ color: "#fa0505" ,size: "medium"}}
                    onClick={() => {
                        props.handleClearImage("watermark")
                        setWatermarkImage(false);
                        setSelectedFileName("");
                    }
                    }
                />)}
          </div>
            </div>
          </div>
           
 {hasWatermarkImage && (
            <>
              <div className="ms-Grid-row" style={{ display: "flex", gap: "16px", marginTop: "10px", flexWrap: "wrap" }}>
                <div style={{ width: "150px" }}>
              <TextField
                label="Opacity(%)"
                type="number"
                    min={0}
                    max={100}
                    value={String(props.values.watermarkOpacity ?? 100)}
                    onChange={handleOpacityChange}
                  />
                </div>
                <div style={{ width: "150px" }}>
              <TextField
                label="Width(%)"
                    min={0}
                    max={100}
                    value={String(props.values.watermarkWidth ?? 100)}
                    onChange={handleWidthChange}
                  />
                </div>

                <div style={{ width: "150px" }}>
              <TextField
                label="Rotation(°)"
                    min={0}
                    max={360}
                    value={String(props.values.watermarkRotation ?? 0)}
                    onChange={handleRotationChange}
                  />
                </div>
              </div>
              <div className="ms-Grid-row" style={{ display: "flex", gap: "16px", marginTop: "10px", flexWrap: "wrap" }}>
                <div style={{ width: "150px" }}>
                  <Slider
                label="Opacity(%)"
                min={0}
                max={100}
                step={1}
                value={props.values.watermarkOpacity ?? 100}
                onChange={(val) => {
                  if (props.setFieldValue) props.setFieldValue("watermarkOpacity", val);
                }}
                showValue
              />
            </div>
            <div style={{ width: "150px" }}>
                  <Slider
                label="Width(%)"
                min={0}
                max={100}
                step={1}
                value={props.values.watermarkWidth ?? 100}
                onChange={(val) => {
                  if (props.setFieldValue) props.setFieldValue("watermarkWidth", val);
                }}
                showValue
              />
            </div>
            <div style={{ width: "150px" }}>
              <Slider
                label="Rotation(°)"
                    min={0}
                    max={360}
                    step={1}
                    value={props.values.watermarkRotation ?? 0}
                    onChange={(val) => {
                      if (props.setFieldValue) props.setFieldValue("watermarkRotation", val);
                    }}
                    showValue
                  />
                </div>
              </div>
            </>
          )}

        </>
      )}
    </div>
  );
};

export default WatermarkConfiguration;
